document.addEventListener("DOMContentLoaded", function () {
  const wrap = document.querySelector(".plx2-wrap");
  if (!wrap) return;

  const mainImg = wrap.querySelector("[data-plx2-img]");
  const thumbStrip = wrap.querySelector("#plx2-thumbstrip");
  const nextBtn = wrap.querySelector("[data-plx2-next]");
  const prevBtn = wrap.querySelector("[data-plx2-prev]");

  let thumbs = [];
  let activeIndex = 0;
  let autoplayTimer = null;

  // ---- Responsive image helpers -------------------------------------
  // Anything that sets the main image's src programmatically must go
  // through setMainImage() so srcset/sizes stay in sync. Setting only
  // `src` (as the old code did) makes the browser re-download the
  // largest version every time, which is what was tripping the
  // Lighthouse "Improve image delivery" audit even after the initial
  // Liquid-side srcset fix.
  const RESPONSIVE_WIDTHS = [300, 400, 500, 600, 800, 1000, 1200];
  const RESPONSIVE_SIZES =
    "(min-width: 992px) 600px, (min-width: 768px) min(600px, calc(100vw - 72px)), calc(100vw - 40px)";

  function withWidth(url, width) {
    if (!url) return url;
    try {
      const u = new URL(url, window.location.origin);
      u.searchParams.set("width", width);
      return u.toString();
    } catch (e) {
      return url;
    }
  }

  function buildSrcset(url) {
    if (!url) return "";
    return RESPONSIVE_WIDTHS.map(function (w) {
      return withWidth(url, w) + " " + w + "w";
    }).join(", ");
  }

  function setMainImage(url, alt) {
    if (!url || !mainImg) return;
    mainImg.src = withWidth(url, 600);
    mainImg.srcset = buildSrcset(url);
    mainImg.sizes = RESPONSIVE_SIZES;
    if (alt !== undefined) mainImg.alt = alt;
  }
  // ---------------------------------------------------------------------

  function goToSlide(index) {
    if (!thumbs.length) return;
    if (index < 0) index = thumbs.length - 1;
    if (index >= thumbs.length) index = 0;
    activeIndex = index;

    thumbs.forEach(function (thumb) { thumb.classList.remove("is-active"); });
    thumbs[activeIndex].classList.add("is-active");

    const fullUrl = thumbs[activeIndex].dataset.plx2Full;
    const altText = thumbs[activeIndex].dataset.plx2Altx || "";
    setMainImage(fullUrl, altText);

    if (thumbStrip) {
      const activeThumb = thumbs[activeIndex];
      const scrollLeft = thumbStrip.scrollLeft;
      const stripWidth = thumbStrip.offsetWidth;
      const thumbLeft = activeThumb.offsetLeft;
      const thumbWidth = activeThumb.offsetWidth;
      if (thumbLeft < scrollLeft) {
        thumbStrip.scrollTo({ left: thumbLeft - 8, behavior: "smooth" });
      } else if (thumbLeft + thumbWidth > scrollLeft + stripWidth) {
        thumbStrip.scrollTo({ left: thumbLeft + thumbWidth - stripWidth + 8, behavior: "smooth" });
      }
    }
  }

  function startAutoplay() {
    stopAutoplay();
    autoplayTimer = setInterval(function () {
      goToSlide(activeIndex + 1);
    }, 5000);
  }

  function stopAutoplay() {
    if (autoplayTimer) {
      clearInterval(autoplayTimer);
      autoplayTimer = null;
    }
  }

  thumbs = [...wrap.querySelectorAll("[data-plx2-thumb]")].slice(0, 6);

  if (mainImg && thumbs.length) {
    activeIndex = 0;
    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener("click", function () {
        stopAutoplay();
        goToSlide(i);
        startAutoplay();
      });
    });
    if (nextBtn) {
      nextBtn.addEventListener("click", function () {
        stopAutoplay();
        goToSlide(activeIndex + 1);
        startAutoplay();
      });
    }
    if (prevBtn) {
      prevBtn.addEventListener("click", function () {
        stopAutoplay();
        goToSlide(activeIndex - 1);
        startAutoplay();
      });
    }
    goToSlide(0);
    startAutoplay();
  }

  const variantJsonEl = document.querySelector('[id^="PlxVJ-"]');
  if (!variantJsonEl) return;
  const variants = JSON.parse(variantJsonEl.textContent);

  function formatMoney(cents) {
    cents = Number(cents);
    return (typeof Shopify !== "undefined" && Shopify.formatMoney)
      ? Shopify.formatMoney(cents, Shopify.money_format)
      : "₹" + parseInt(cents / 100).toLocaleString("en-IN");
  }

  function applyVariant(variant) {
    if (!variant) return;
    const url = new URL(window.location.href);
    url.searchParams.set("variant", variant.id);
    window.history.replaceState({}, "", url.toString());

    const idInput = document.querySelector("[data-plx2-varid]");
    if (idInput) idInput.value = variant.id;

    document.querySelectorAll("[data-plx2-price]").forEach(function (el) {
      el.innerHTML = formatMoney(variant.price);
    });

    const cmpEls = document.querySelectorAll("[data-plx2-cmp]");
    const saveEls = document.querySelectorAll("[data-plx2-save]");
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      const pct = Math.round(
        ((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100
      );
      cmpEls.forEach(function (el) {
        el.classList.remove("is-hidden");
        el.innerHTML = formatMoney(variant.compare_at_price);
      });
      saveEls.forEach(function (el) {
        el.classList.remove("is-hidden");
        el.innerHTML = pct + "% OFF";
      });
    } else {
      cmpEls.forEach(function (el) { el.classList.add("is-hidden"); });
      saveEls.forEach(function (el) { el.classList.add("is-hidden"); });
    }

    if (variant.featured_image && variant.featured_image.src) {
      setMainImage(variant.featured_image.src, mainImg ? mainImg.alt : undefined);
    }

    document.querySelectorAll("[data-plx2-atc]").forEach(function (btn) {
      btn.disabled = !variant.available;
      btn.innerHTML = variant.available ? "ADD TO CART" : "SOLD OUT";
    });
  }

  const variantCards = document.querySelectorAll(".plx2-vcard");
  variantCards.forEach(function (card) {
    card.addEventListener("click", function () {
      variantCards.forEach(function (c) { c.classList.remove("active"); });
      card.classList.add("active");
      const variant = variants.find(function (v) {
        return String(v.id) === String(card.dataset.plx2Vid);
      });
      if (variant) applyVariant(variant);
    });
  });

  const offersToggle = document.querySelector("[data-plx2-otoggle]");
  const offersBody = document.querySelector("[data-plx2-obody]");
  const offersArrow = document.querySelector(".plx2-offarrow");
  if (offersToggle && offersBody) {
    offersToggle.addEventListener("click", function () {
      const isOpen = offersBody.style.display !== "none";
      offersBody.style.display = isOpen ? "none" : "block";
      if (offersArrow) offersArrow.style.transform = isOpen ? "rotate(-90deg)" : "rotate(0deg)";
      this.setAttribute("aria-expanded", String(!isOpen));
    });
  }

  const form = document.querySelector(".plx2-form");
  if (form) {
    form.addEventListener("submit", async function (e) {
      e.preventDefault();
      const atcBtn = document.querySelector("[data-plx2-atc]");
      try {
        if (atcBtn) atcBtn.innerHTML = "ADDING...";
        const res = await fetch("/cart/add.js", { method: "POST", body: new FormData(form) });
        if (!res.ok) throw new Error("Cart Error");
        if (atcBtn) atcBtn.innerHTML = "ADDED ✓";
        document.dispatchEvent(new CustomEvent("cart:refresh"));
        document.dispatchEvent(new CustomEvent("cart:open"));
        setTimeout(function () {
          if (atcBtn) atcBtn.innerHTML = "ADD TO CART";
        }, 1500);
      } catch (err) {
        console.error(err);
        form.submit();
      }
    });
  }

  const qtyMinus = wrap.querySelector("[data-plx2-qminus]");
  const qtyPlus = wrap.querySelector("[data-plx2-qplus]");
  const qtyInput = wrap.querySelector("[data-plx2-qinput]");
  if (qtyMinus && qtyPlus && qtyInput) {
    qtyMinus.addEventListener("click", function () {
      const v = parseInt(qtyInput.value, 10);
      if (v > 1) qtyInput.value = v - 1;
    });
    qtyPlus.addEventListener("click", function () {
      qtyInput.value = parseInt(qtyInput.value, 10) + 1;
    });
  }

  const sizeButtons = document.querySelectorAll(".plx2-szbtn");
  const recipeButtons = document.querySelectorAll(".plx2-rcbtn");
  let activeSize = document.querySelector(".plx2-szbtn.active")
    ? document.querySelector(".plx2-szbtn.active").dataset.plx2Size
    : null;
  let activeRecipe = document.querySelector(".plx2-rcbtn.active")
    ? document.querySelector(".plx2-rcbtn.active").dataset.plx2Recipe
    : null;

  function updateVariantCards() {
    let matched = null;
    variantCards.forEach(function (card) {
      const sizeMatch = card.dataset.plx2Size === activeSize;
      const recipeMatch = card.dataset.plx2Recipe === activeRecipe;
      const isMatch = sizeMatch && recipeMatch;
      card.style.display = isMatch ? "" : "none";
      if (isMatch && !matched) matched = card;
    });
    if (matched) {
      variantCards.forEach(function (c) { c.classList.remove("active"); });
      matched.classList.add("active");
      const variant = variants.find(function (v) {
        return String(v.id) === String(matched.dataset.plx2Vid);
      });
      if (variant) applyVariant(variant);
    }
  }

  sizeButtons.forEach(function (btn) {
    btn.addEventListener("click", function () {
      sizeButtons.forEach(function (b) { b.classList.remove("active"); });
      this.classList.add("active");
      activeSize = this.dataset.plx2Size;
      updateVariantCards();
    });
  });
  recipeButtons.forEach(function (btn) {
    btn.addEventListener("click", function () {
      recipeButtons.forEach(function (b) { b.classList.remove("active"); });
      this.classList.add("active");
      activeRecipe = this.dataset.plx2Recipe;
      updateVariantCards();
    });
  });

  updateVariantCards();

  document.addEventListener("click", function (e) {
    const tag = e.target.closest(".plx2-otag");
    if (!tag) return;
    const code = tag.dataset.plx2Coupon;
    navigator.clipboard.writeText(code);
    const original = tag.innerText;
    tag.innerText = "Copied ✓";
    setTimeout(function () {
      tag.innerText = original;
    }, 2000);
  });
});
